import {defineStore} from 'pinia'
import {useUserStore} from "@/stores/user";
import router from "@/router";

export const useMediaCategoryStore = defineStore('media_category', {
    // a function that returns a fresh state
    state: () => ({

    }),
    // optional getters
    getters: {},
    // optional actions
    actions: {
        index(kdnr) {
            kdnr = kdnr || useUserStore().user.organisation.kdnr || router.currentRoute.value.query.kdnr
            return this.apiClient.get(`/asset_categories?kdnr=${kdnr}`)
        },
        create(kdnr, name) {
            return this.apiClient.post(`/asset_categories`, {kdnr, asset_category: {name}})
        },

    }
})
